export enum AccessEnums {
  AdminAclSectionsList = "admin.acl_sections.list",
  AdminAclSectionsCreate = "admin.acl_sections.create",
  AdminAclSectionsUpdate = "admin.acl_sections.update",
  AdminAclRolesList = "admin.acl_roles.list",
  AdminAclRolesCreate = "admin.acl_roles.create",
  AdminAclRolesUpdate = "admin.acl_roles.update",
  AdminAclRolesDetails = "admin.acl_roles.details",
  AdminTicketsList = "admin.tickets.list",
  AdminTicketsDetails = "admin.tickets.details",
  AdminTicketsAnswer = "admin.tickets.answer",
  AdminTicketsClose = "admin.tickets.close",
  AdminWorkspacesList = "admin.workspaces.list",
  AdminUsersList = "admin.users.list",
  AdminPaymentReceiptsList = "admin.payment_receipts.list",
  AdminPaymentReceiptsDetails = "admin.payment_receipts.details",
  AdminPbxServersList = "admin.pbx_servers.list",
  AdminPbxServersCreate = "admin.pbx_servers.create",
  AdminPbxServersUpdate = "admin.pbx_servers.update",
  AdminPbxServersDelete = "admin.pbx_servers.delete",
  AdminPbxTrunksList = "admin.pbx_trunks.list",
  AdminPbxTrunksCreate = "admin.pbx_trunks.create",
  AdminPbxTrunksUpdate = "admin.pbx_trunks.update",
  AdminPbxTrunksDelete = "admin.pbx_trunks.delete",
  AdminFilesList = "admin.files.list",
  AdminFilesVerified = "admin.files.verified",
  AdminFilesRejected = "admin.files.rejected",
  AdminPaymentGatewayList = "admin.payment_gateway.list",
  AdminPaymentGatewayCreate = "admin.payment_gateway.create",
  AdminWalletsList = "admin.wallets.list",
  AdminTransactionsList = "admin.transactions.list",
  AdminVoiceBroadcastsList = "admin.voice_broadcasts.list",
  AdminVoiceBroadcastsCancel = "admin.voice_broadcasts.cancel",
  AdminAclSectionsSyncWithRoutes = "admin.acl_sections.sync_with_routes",
  AdminTicketsSendToInProgress = "admin.tickets.sendToInProgress",
  AdminVoiceBroadcastNumbersList = "admin.voice_broadcast_numbers.list",
  AdminPbxCallDetailRecordsList = "admin.pbx_call_detail_records.list",
  AdminPartnerList = "admin.partner.list",
  AdminPartnerCreate = "admin.partner.create",
  AdminPartnerUpdate = "admin.partner.update",
  AdminPartnerDelete = "admin.partner.delete",
  AdminAccessTokensList = "admin.access_tokens.list",
  AdminAccessTokensCreate = "admin.access_tokens.create",
  AdminAccessTokensDelete = "admin.access_tokens.delete",
  AdminPaymentGatewayUpdate = "admin.payment_gateway.update",
  AdminWalletsIncrease = "admin.wallets.increase",
  AdminWalletsDecrease = "admin.wallets.decrease",
  AdminSecureCallsList = "admin.secure_calls.list",
  AdminOTPCallsList = "admin.otp_calls.list",
  AdminLogsList = "admin.logs.list",
  AdminLogsDetails = "admin.logs.details",
  AdminPartnerResetStatus = "admin.partner.reset_status",
  AdminVoiceBroadcastsUpdate = "admin.voice_broadcasts.update",
  AdminReportsCallQueueSender = "admin.reports.call_queue_sender",
  AdminPartnerDetails = "admin.partner.details",
  AdminReportsVoicebroadcastsReport = "admin.reports.voice_broadcasts.report",
  AdminReportsVoicebroadcastsReset = "admin.reports.voice_broadcasts.reset",
  AdminBlockNumbersList = "admin.block_numbers.list",
  AdminBlockNumbersCreate = "admin.block_numbers.create",
  AdminBlockNumbersUpdate = "admin.block_numbers.update",
  AdminBlockNumbersDelete = "admin.block_numbers.delete",
  AdminSendCallsList = "admin.send_calls.list",
  AdminShowAccessToken = "admin.access_tokens.show_token",
}
